import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import category_template from '~/templates/category-details.handlebars';
import Ranking_template from '~/templates/ranking.handlebars';
import getAlertService from '~/services/alertService';
import getUtilsService from '~/services/utilsService';
import GeneralView from '~/generalView';
import toastr from 'toastr';

var CategoryView = GeneralView.View.extend({
	className: 'categoryView',
	count: 0,
	report: [],
	rendered: false,
	subCategories: null,
	status : '',
	assigned : '',
	my: '',
	priorityarray : [],
	datearray: [],
	prioritybol : false,
	categoryData: null,
	events: {
		'click .filtersubbtn' : 'changeorder',
		'click .member-infossubcats' : 'checkarrow',
		'keyup #searchreportsinput' : 'searchreports',
		'click .cancelsearch' : "cancelsearch",
	},

	render: function() {
		var handlebarsTemplate = Handlebars.template(category_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.container').hide();
		this.attachEvents();
		return this;
	},

	checkarrow: function(e){
		var id = e.currentTarget.id.substring(3,e.currentTarget.id.length);
		var uparrow = 'arrowup-'+id;
		var downarrow = 'arrowdown-'+id;
		if ($('.'+uparrow).is(":visible")) {
			$('.'+uparrow).hide(); 
			$('.'+downarrow).show();
		}
		else{
			$('.'+uparrow).show();
			$('.'+downarrow).hide();
		}
	},

	attachEvents: function() {
		this.listenTo(EventHub, 'category:setState', data => {
			this.status = data.status;
			this.assigned = data.assigned;
			this.my = data.my;
			this.categoryData = data.category;
			data.reports.sort(function(a, b){
				a.length - b.length
				return b.length - a.length;
			});
			var subcats = [];
			for (var i = 0; i < data.reports.length; i++) {
				//array order the subcat with more reports
				if(data.reports[i].length > 0){
					subcats.push(data.reports[i][0].attributes.subCategory);
					for (var j = 0; j < data.subcategories.models.length; j++) {
						if (data.reports[i][0].attributes.subCategory.id == data.subcategories.models[j].id) {
							data.subcategories.models.splice(j,1);
						}
					}
				}
			}
			for (var j = 0; j < data.subcategories.models.length; j++) {
				data.subcategories.models[j].attributes.name = data.subcategories.models[j].attributes.name +": No hay reportes"
				subcats.push(data.subcategories.models[j]);
			}
			this.subCategories = subcats;
			this.renderReport();
			if (data.reports[0].length > 0) {
				$('.subcategloader').show();
			}
			else{
				$('.subcategloader').hide();
			}
			for (var i = 0; i < data.reports.length; i++) {
				if (data.reports[i].length > 0) {
					this.fetchRanking(data.reports[i]);
				}
			}
			$("#containersubcats").show();
			$("#tablecontainer").show();
			$(".tablemaincontainer").hide();

		});
	},

	fetchRanking: function(reportsCollection) {
		this.datearray.push(reportsCollection);
		this.doPlotReports(reportsCollection);
		this.dopriorityarray(reportsCollection);
		$('#Datefiltersubbtn').css({"background-color" : "white" , "color" : "black", "cursor": "not-allowed","pointer-events": "none"});
		$('#Priorityfiltersubbtn').css({"background-color" : "var(--blue-button)" , "color" : "white", "border-color" : "#2e6da4", "cursor": "pointer","pointer-events": "all"});
	},

	dopriorityarray: function(reports){
		var nopriority = [];
		var lowpriority = [];
		var midpriority = [];
		var highpriority = [];
		for (var i = 0; i < reports.length; i++) {
			reports[i].attributes.priority
			if(reports[i].attributes.priority == undefined) {
				nopriority.push(reports[i]);
			}
			if(reports[i].attributes.priority == 1) {
				lowpriority.push(reports[i]);
			}
			if(reports[i].attributes.priority == 2) {
				midpriority.push(reports[i]);
			}
			if(reports[i].attributes.priority == 3) {
				highpriority.push(reports[i]);
			}
		}
		var subcatcarray = highpriority.concat(midpriority,lowpriority,nopriority);
		this.priorityarray.push(subcatcarray);
	},

	changeorder: function(e){
		var opt = $(e.currentTarget).attr('value');;
		this.prioritybol = true;
		if (opt == 'priority') {
			for (var i = 0; i < this.priorityarray.length; i++) {
				this.doPlotReports(this.priorityarray[i]);
			}
			$('#Priorityfiltersubbtn').css({"background-color" : "white" , "color" : "black", "cursor": "not-allowed","pointer-events": "none"});
			$('#Datefiltersubbtn').css({"background-color" : "#337ab7" , "color" : "white", "border-color" : "#2e6da4", "cursor": "pointer","pointer-events": "all"});
		}
		else{
			$('#Datefiltersubbtn').css({"background-color" : "white" , "color" : "black", "cursor": "not-allowed","pointer-events": "none"});
			$('#Priorityfiltersubbtn').css({"background-color" : "#337ab7" , "color" : "white", "border-color" : "#2e6da4", "cursor": "pointer","pointer-events": "all"});
			for (var i = 0; i < this.datearray.length; i++) {
				this.doPlotReports(this.datearray[i]);
			}
		}
	},

	doPlotReports: function(reports) {
		var rankingTable = Handlebars.template(Ranking_template);
		$('#'+reports[0].attributes.subCategory.id+'number div').html(reports.length+ "");
		for (var i = 0; i < reports.length; i++) {
			var tablereportfield = 'Descripci&oacute;n';
			if (reports[0].attributes.customreportvalues !=  undefined && reports[0].attributes.customreportvalues.customdata !=  undefined && reports[0].attributes.customreportvalues.customdata.length > 0) {
				tablereportfield = reports[0].attributes.customreportvalues.customdata[0].name;
			}
			$('#'+reports[i].attributes.subCategory.id).empty();
			$('#tablereportssubcategory-'+reports[i].attributes.subCategory.id).empty()
			var daysOpen = '';
			if(this.status == 'open'){
				daysOpen = '<th class="daysopentablesubcat">Días activo</th>';
			}
			$('#tablereportssubcategory-'+reports[i].attributes.subCategory.id).append('<tr><th class="datetablesubcat">Fecha</th><th class="codetablesubcat">C&oacute;digo</th><th class="prioritytablesubcat">Prioridad</th>'+ daysOpen +'<th class="descriptiontablesubcat">Descripci&oacute;n</th><th class="optionstablesubcat">Ir al reporte</th></tr>');
		}
		for (var i = 0; i < reports.length; i++) {
			if (this.prioritybol != true) {
				var newdate = new Date();
				newdate = reports[i].attributes.createdAt.toLocaleDateString('en-GB');
				reports[i].date = newdate;
			}
			var open = true;
			if(reports[i].attributes.status != 'open') {
				open = false;
			}
			$("#dottittle-"+reports[i].id).attr("title", arrlang[lang]["nopriority"]);
			var reppriority = 'Prioridad Sin Asignar';
			var color = '';
			if (reports[i].attributes.priority == 1) {
				$("#dot-"+reports[i].id).css("background-color", "#7CFC00");
				$("#dottittle-"+reports[i].id).attr("title", arrlang[lang]["lowpriority"]);
				color = '#7CFC00';
				reppriority = 'Prioridad Baja';
			}
			if (reports[i].attributes.priority == 2) {
				$("#dot-"+reports[i].id).css("background-color", "#FFFF00");
				$("#dottittle-"+reports[i].id).attr("title", arrlang[lang]["midpriority"]);
				color = 'var(--yellow-priority-badge)';
				reppriority = 'Prioridad Media';
			}
			if (reports[i].attributes.priority == 3) {
				$("#dot-"+reports[i].id).css("background-color", "#FF0000");
				$("#dottittle-"+reports[i].id).attr("title", arrlang[lang]["highpriority"]);
				color = '#FF0000';
				reppriority = 'Prioridad Alta';
			}
			//var resportdescription = reports[i].attributes.description;
			var resportdescription = '';
			if (reports[i].attributes.customreportvalues !=  undefined && reports[i].attributes.customreportvalues.customdata !=  undefined && reports[0].attributes.customreportvalues.customdata.length > 0) {
				for(var j=0; j<reports[i].attributes.customreportvalues.customdata.length;++j){
					if(reports[i].attributes.customreportvalues.customdata[j].type != "file"){
						resportdescription = reports[i].attributes.customreportvalues.customdata[j].val;
						break;
					}
				}
			}
			var reportDate = reports[i].attributes.createdAt;
			var currentDate = new Date();
			var differenceInMs = currentDate.getTime() - reportDate.getTime();
			var differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
			var daysOpenData = '';
			if(this.status == 'open'){
				daysOpenData = '<td>'+differenceInDays+' día(s)</td>';
			}
			$('#tablereportssubcategory-'+reports[i].attributes.subCategory.id).append('<tr><td>'+reports[i].date+'</td><td>'+reports[i].id+'</td><td><i class="bi bi-exclamation-diamond-fill" style="color: '+color+'; font-size: 20px;"></i> '+reppriority+'</td>'+ daysOpenData +'<td>'+resportdescription+'</td><td class="categoryactionbtns"><a class="action detailsreport" href="#report/'+reports[i].id+'" id="detailsreport" title="Ver detalles del Reporte"><i class="bi bi-arrow-right-square-fill"></i></a><a href="#report/'+reports[i].id+'" > <i class="fa-exclamation-circle fa fa-lg badge_normal" id="badge-report-'+reports[i].id+'" title="Reporte Actualizado"></i><i class="fa-exclamation-circle fa fa-lg badge_noresponse" id="badge_noresponse-report-'+reports[i].id+'" title="Reporte Sin Respuesta"></i></a></td></tr>')
		}
		getAlertService().fetch({
			all: true,
			cache: false,
			rules:{
				equals: [{
					key: 'usersRelated',
					val: {__type: "Pointer", className: "_User", objectId: Parse.User.current().id }
				}]
			}
		}).then(data => {
			for(var i=0; i< data.models.length; ++i){
				var badge = $('#badge-report-'+data.models[i].attributes.report.id);
				if(badge.length>0){
					if(data.models[i].attributes.kind != 'noresponse'){
						badge.show();
						badge.attr("title", arrlang[lang]["newreporticon"])
						$('#badge-report-subcategory-'+data.models[i].attributes.report.attributes.subCategory.id).show();
						$('#badge-report-subcategory-'+data.models[i].attributes.report.attributes.subCategory.id).attr("title", arrlang[lang]["newreports"]);
					}
					else{
						badge = $('#badge_noresponse-report-'+data.models[i].attributes.report.id);
						badge.show();
						badge.attr("title", arrlang[lang]["ReportBadgeNoResponse"])
						$('#badge_noresponse-report-subcategory-'+data.models[i].attributes.report.attributes.subCategory.id).show();
						$('#badge_noresponse-report-subcategory-'+data.models[i].attributes.report.attributes.subCategory.id).attr("title", arrlang[lang]["SubCatBadgeNoResponse"]);
					}
				}
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('.subcategloader').hide();
		$("#containersubcats").show();
		$("#tablecontainer").show();
		this.translate();
	},

	renderReport: function() {
		if(!this.rendered) {
			this.rendered = true;
			this.$el.empty();
			var handlebarsTemplate = Handlebars.template(category_template);
			var tittle = arrlang[lang]['newtittle2'];
			if (this.status == 'open' && this.assigned == true) {
				tittle = arrlang[lang]['asigntittle2'];
			}
			if (this.my != undefined) {
				tittle = arrlang[lang]['myreportstittle'];
			}
			if (this.status == 'close' && this.assigned == undefined) {
				tittle = arrlang[lang]['archivetittle2'];
			}
			this.$el.html(handlebarsTemplate({ category: this.categoryData, subCategories: this.subCategories, tittle : tittle }));
		}
	},
	
	cancelsearch: function(){
		location.reload();
	},
	
	searchreports: function(){
		var that = this;
		$(".filetsubcatcontainer").hide();
		var permissions = getUtilsService.getprofilepermissions();
		$('.subcategloader').show();
		$('.totalofreports').hide();
		$('.foundreports-table').empty();
		$('#containersubcats').hide();
		$('#searchTitle').hide();
		$('#contentcategory').hide();
		$('#selectkindofreports').hide();
		var val = $("#searchreportsinput").val();
		val = val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		var re = new RegExp(val, 'g');
		clearTimeout(this.timeout);
		this.timeout = setTimeout(function () {
			if (val.length >= 3) {
				Parse.Cloud.run("getallreportssubcat",{"search": val, 'categoryId': that.categoryData.id}).then((allfoundreports) => {
					$('#searchTitle').show();
					$('.foundreports-table').show();
					if (allfoundreports.length > 0) {
						$('.foundreports-table').append('<tr><th class="infotableheader item" key="tableheadernew">Reporte</th> <th class="infotableheader item" key="tableheaderclosed">Descripci&oacute;n</th><th class="infotableheader item" key="tableheaderassigned">Subcategor&iacute;a</th><th class="infotableheader item" key="tableheaderassigned">Fecha</th><th class="infotableheader item" key="tableheaderstatus">Estado</th><th class="infotableheader item" key="tablecomments">Comentarios</th></tr>');
					}
					var totalr = 0;
					for (var i = 0; i < allfoundreports.length; i++) {
						var supercat = "Sin definir";
						var subcat = "Sin definir";
						var permission = false;
						if (allfoundreports[i].report.attributes.subCategory != undefined) {
							if (jQuery.isEmptyObject(allfoundreports[i].report.attributes.subCategory.attributes) == false) {
								permission = permissions.categories.includes(allfoundreports[i].report.attributes.subCategory.attributes.superCat.id);
								supercat = allfoundreports[i].report.attributes.subCategory.attributes.superCat.attributes.name;
								subcat = allfoundreports[i].report.attributes.subCategory.attributes.name;
							}
						}
						if(permission){
							var desc = '';
							if(allfoundreports[i].report.attributes.description != undefined){
								desc = allfoundreports[i].report.attributes.description.replace(re, `<mark>$&</mark>`);
							}
							else{
								desc = allfoundreports[i].report.attributes.description;
								if (allfoundreports[i].report.attributes.customreportvalues != undefined) {
									desc = allfoundreports[i].report.attributes.customreportvalues.customdata[0].val;
								}
							}
							var user = 'Sin definir';
							if (allfoundreports[i].report.attributes.userName != undefined) {
								if (allfoundreports[i].report.attributes.userName != "") {
									user = allfoundreports[i].report.attributes.userName.replace(re, `<mark>$&</mark>`);
								}
							}
							var statusInfo = '';
							switch(allfoundreports[i].report.attributes.status){
								case 'open':
									statusInfo = '<td class="searhtableinfo searchtabledata" key"ReportStatus1">Abierto</td>'
								break;
								case 'close':
									statusInfo = '<td class="searhtableinfo searchtabledata" key"ReportStatus2">Cerrado</td>'
								break;
								case 'discard':
									statusInfo = '<td class="searhtableinfo searchtabledata" key"ReportStatus3">Descartado</td>'
								break;
							}
							var d =  new Date();
							var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
							d = allfoundreports[i].report.attributes.createdAt.toLocaleDateString('es-GB', options);
							$('.foundreports-table').append('<tr><td class="searhtableinfo"><a href="#report/'+allfoundreports[i].report.id+'"><button type="button" class="btn btn-primary gotoreportbtn">Ver reporte</button></a></td><td class="searhtableinfo searchtabledata">'+desc+'</td><td class="searhtableinfo searchtabledata">'+subcat+'</td><td class="searhtableinfo searchtabledata">'+d+'</td>'+statusInfo+'<td class="searhtableinfo searchtabledata tabcomment "><ul class="'+allfoundreports[i].report.id+'"></ul></td></tr>');
							totalr++;
							if (allfoundreports[i].comments.length > 0) {
								for (var l = 0; l < allfoundreports[i].comments.length; l++) {
									var comm = allfoundreports[i].comments[l].replace(re, `<mark>$&</mark>`);
									$("."+allfoundreports[i].report.id).append('<li style="text-align:left;">'+comm+'</li>');
								}
							}
						}
					}
					$('.subcategloader').hide();
					$('.totalofreports').show();
					$('.totalofreports').text("Se encontraron " +totalr +" reportes");
					$('.cancelsearch').show();
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['SearchReportsError'],'Error');
						break;
					}
				});
			}
			else{
				$('.totalofreports').hide();
				$('.subcategloader').hide();
				$('.totalofreports').show();
				$('#containersubcats').show();
				$('#contentcategory').show();
				$('#selectkindofreports').show();
				$('#searchTitle').hide();
				$(".cancelsearch").show();
			}
		}, 1000);
	},
});
export default CategoryView;
